const React = require("react");
const T = require("prop-types");
const moment = require("moment");
const Style = require("./styles.scss");
const Deeply = require("utils/deeply");

const ordering = {
    UPCOMING: 0,
    "EXPIRING SOON": 1,
    ACTIVE: 2
};

module.exports = class Dashboard extends React.Component {
    static propTypes = {
        isFetching: T.bool.isRequired,
        items: T.array,
        hasFetchedAll: T.bool.isRequired,

        fetchPromoCodes: T.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            items: this.updateItems(props.items || [])
        };
    }

    componentDidMount() {
        if (!this.props.hasFetchedAll) {
            this.props.fetchPromoCodes();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.items != this.props.items) {
            this.setState({
                items: this.updateItems(this.props.items)
            });
        }
    }

    updateItems(items) {
        const cutoff = moment.duration({ days: 10 });
        const now = moment.utc();

        items = Deeply(items).value();

        for (const item of items) {
            if (item.endDate && item.endDate < now) {
                item.status = "EXPIRED";
            } else if (item.endDate && item.endDate < now.add(cutoff)) {
                item.status = "EXPIRING SOON";
            } else if (item.startDate && item.startDate > now) {
                item.status = "UPCOMING";
            } else {
                item.status = "ACTIVE";
            }
        }

        return items;
    }

    renderPromoDate(promo) {
        const now = moment.utc();

        if (promo.startDate && promo.startDate > now) {
            return "starts " + promo.startDate.format("L");
        } else if (promo.endDate && promo.endDate > now) {
            return "ends " + promo.endDate.format("L");
        } else {
            return "never expires";
        }
    }

    renderPromoStatus(promo) {
        let cls, text;

        switch (promo.status) {
            case "EXPIRED":
                cls = "status-expired";
                text = "EXPIRED";
                break;

            case "EXPIRING SOON":
                cls = "status-expiring-soon";
                text = (
                    <React.Fragment>
                        EXPIRING
                        <br />
                        SOON
                    </React.Fragment>
                );
                break;

            case "UPCOMING":
                cls = "status-upcoming";
                text = "UPCOMING";
                break;

            case "ACTIVE":
                cls = "status-active";
                text = "ACTIVE";
                break;
        }

        return <span className={Style[cls]}>{text}</span>;
    }

    renderPromoCodeTable() {
        if (this.state.items == null) {
            return "Not loaded yet";
        }

        let items = this.state.items.filter(p => p.status != "EXPIRED");
        items.sort((a, b) => ordering[a.status] - ordering[b.status]);
        items = items.map(p => (
            <tr key={p.id}>
                <td className={Style.promoStatus}>
                    {this.renderPromoStatus(p)}
                </td>
                <td>
                    <span className={Style.promoCode}>{p.code}</span> (
                    {p.discount * 100}%)
                </td>
                <td className={Style.promoDate}>{this.renderPromoDate(p)}</td>
            </tr>
        ));

        return (
            <div className={Style.promoTable}>
                <table>
                    <tbody>{items}</tbody>
                </table>
            </div>
        );
    }

    render() {
        return (
            <div>
                <h1>Admin Dashboard</h1>

                <h2>Non-expired Promo Codes</h2>
                <div>{this.renderPromoCodeTable()}</div>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/admin-dashboard/components/Dashboard.js